module.exports = __webpack_public_path__ + "img/selected0-min.26cac8a5.png";